import { jwtDecode } from "jwt-decode";

/**
 * Whether the access token carries a non-empty `urn:visioni:branches` claim.
 *
 * vision-auth sets that claim from the user's Microsoft (Entra) groups, and
 * the realm authorizer turns it into tenant and site access on each request.
 * That access is never stored as a grant, so notification recipients, which are
 * resolved from stored grants only, never include these users.
 */
export function hasBranchClaim(accessToken: string | null): boolean {
  if (!accessToken) return false;
  try {
    const branches = jwtDecode<{ "urn:visioni:branches"?: unknown }>(accessToken)["urn:visioni:branches"];
    return Array.isArray(branches) && branches.length > 0;
  } catch {
    return false;
  }
}
